<template>
  <div class="modal" v-bind:style="show">
    <div class="overlay"></div>
    <div class="modal_content">
      <!-- Dynamic Section -->
      <img src="../assets/smm-logo.png" alt="sinarmas mining" height="42px">
      <div>
        <img class="inline" src="../assets/i.png" alt="i">
        <p class="inline">&nbsp;&nbsp;</p>
        <h1 class="inline">Cosystem</h1>
      </div>
      <div class="icon-wrap" @click="goto(1)">
        <img height="10px" class="icon" src="../assets/search-solid.svg">
        <h3>iSearch</h3>
      </div>
      <div class="icon-wrap" @click="goto(2)">
        <img class="icon" src="../assets/laptop-solid.svg">
        <h3>iRequest</h3>
      </div>
      <div class="icon-wrap" @click="goto(4)">
        <img class="icon" src="../assets/file-alt-regular.svg">
        <h3>iMemo</h3>
      </div>
      <!-- End of Dynamic Section -->
      <button title="Close" class="close_modal" @click="goto(0)">
        <img width="20px" height="20px" src="../assets/close.svg" alt="close">
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Landing",
  data: function() {
    return {
      show: this.check() ? "display:none" : "display:block"
    };
  },
  methods: {
    goto: function(n) {
      let url = false;
      switch (n) {
        case 1:
          url = "http://isearch.sinarmasmining.com/?sm=1";
          break;
        case 2:
          url = "https://irequest.sinarmasmining.com/#/login?sm=1";
          break;
        // case 3:
        //   url = "https://ichat.sinarmasmining.com/?sm=1";
        //   break;
        case 4:
          url = "https://imemo.sinarmasmining.com/#/login?sm=1";
          break;
      }
      document.cookie = "skipModal=1";
      if (url) window.location.href = url;
      this.show = "display:none";
    },
    check: function() {
      const noNeedModal =
        document.cookie.match("skipModal") ||
        window.location.href.match("sm=1");
      return noNeedModal;
    }
  }
};
</script>

<style>
modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 990;
}

.modal .overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 995;
  background: rgba(0, 0, 0, 0.6);
}

.modal .modal_content {
  z-index: 999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  overflow: auto;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  text-align: center;
  width: 800px; /* This just a default width */
}

.modal .modal_content > h2 {
  font-size: 28px;
  font-weight: 400;
  margin: 20px 0 40px;
  text-align: center;
}

.modal .modal_content .buttons_wrapper {
  padding: 20px;
}

.modal .close_modal {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
  font-size: 18px;
  opacity: 0.5;
  background: none;
  border: none;
  transition: opacity 0.2s ease;
}

.modal .close_modal:hover {
  opacity: 0.9;
}

.icon-wrap {
  display: inline-block;
  text-align: center;
  height: 120px;
  width: 120px;
  margin: 20px;
  cursor: pointer;
  border: 2px solid white;
}

.icon-wrap:hover {
  border: 2px solid teal;
}

.icon {
  display: inline-block;
  width: 64px;
  height: 64px;
  margin: 5px;
  background: #fff;
  border-radius: 10px;
}

.inline {
  display: inline-block;
}

img.inline {
  vertical-align: middle;
  height: 36px;
  margin-bottom: 20px;
}

h1.inline {
  font-size: 48px;
  color: #06ad13;
}
</style>
